import { styled } from "@mui/material/styles";
import { InputLabel } from "@mui/material";

const MyTextLabel = styled(InputLabel)(({ theme }) => ({
  fontFamily: "Plus Jakarta Sans",
  color: "#F8F7F9",
  fontWeight: 500,
  fontSize: "1.2rem",
  "&.Mui-focused": {
    color: "#F8F7F9",
  },
}));

export default MyTextLabel;
